/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */

export function defineOnboarding (i18n) {
  i18n.onboarding = {}
  i18n.onboarding.facerandom = 'Nouveau visage'
  i18n.onboarding.fullsize = 'Pleine taille'
  i18n.onboarding.return = 'Revenir'
  i18n.onboarding.continue = 'Continuer'
  i18n.onboarding.submit = 'Terminer'
  i18n.onboarding.name_please = 'Veuillez choisir un nom.'
  i18n.onboarding.name_not_conform = 'Veuillez choisir un nom comportant uniquement des lettres.'
  i18n.onboarding.choose_name = 'Choisis ton nom'
  i18n.onboarding.choose_description = 'Décris-toi en quelques mots (facultatif)'
  i18n.onboarding.email = 'Email'
  i18n.onboarding.password = 'Mot de passe'
  i18n.onboarding.see_password = 'Voir le mot de passe'

  i18n.onboarding.error = {}
  i18n.onboarding.error.email = 'Veuillez saisir une adresse email.'
  i18n.onboarding.error.email_correct = 'Veuillez saisir une adresse email correcte.'
  i18n.onboarding.error.password = 'Veuillez saisir un mot de passe.'
  i18n.onboarding.error.password_correct = 'Veuillez saisir un mot de passe respectant les conditions.'
  i18n.onboarding.error.both = 'Veuillez saisir votre adresse email et votre mot de passe.'

  i18n.onboarding.password_requirement = {}
  i18n.onboarding.password_requirement.min8 = 'Minimum 8 caractères'
  i18n.onboarding.password_requirement.letter = 'Une lettre (majuscule ou minuscule)'
  i18n.onboarding.password_requirement.digit = 'Un chiffre'
  i18n.onboarding.password_requirement.special = 'Un caractère special (.:;,?!@#$%^&*+_/\'"{}()[] -)'
}
